"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayWrappersType = void 0;
const Utils_1 = require("../../../utils/Utils");
exports.StringArrayWrappersType = Utils_1.Utils.makeEnum({
    Variable: 'variable',
    Function: 'function',
});
